export default "__VITE_ASSET__BnDtbZNt__"